/**
 * @generated SignedSource<<538b470fb791ca390c3c3345e29799d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useTicketDetailLookupBySlugQuery$variables = {
  slug: string;
};
export type useTicketDetailLookupBySlugQuery$data = {
  readonly viewer: {
    readonly ticketDetailBySlug: {
      readonly ticket: {
        readonly id: string;
        readonly slug: string;
      };
    } | null;
  } | null;
};
export type useTicketDetailLookupBySlugQuery = {
  variables: useTicketDetailLookupBySlugQuery$variables;
  response: useTicketDetailLookupBySlugQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "slug",
      "variableName": "slug"
    }
  ],
  "concreteType": "TicketDetail",
  "kind": "LinkedField",
  "name": "ticketDetailBySlug",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Ticket",
      "kind": "LinkedField",
      "name": "ticket",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTicketDetailLookupBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTicketDetailLookupBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a51920e15bde25e322175d3902286140",
    "id": null,
    "metadata": {},
    "name": "useTicketDetailLookupBySlugQuery",
    "operationKind": "query",
    "text": "query useTicketDetailLookupBySlugQuery(\n  $slug: String!\n) {\n  viewer {\n    ticketDetailBySlug(slug: $slug) {\n      ticket {\n        id\n        slug\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "47d8cba7c42ac86786473f9193c7f0b4";

export default node;
